/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { ProductDescriptionSettingsDTOPromptPlaceholders } from "./ProductDescriptionSettingsDTOPromptPlaceholders";
import {
  ProductDescriptionSettingsDTOPromptPlaceholdersFromJSON,
  ProductDescriptionSettingsDTOPromptPlaceholdersFromJSONTyped,
  ProductDescriptionSettingsDTOPromptPlaceholdersToJSON
} from "./ProductDescriptionSettingsDTOPromptPlaceholders";

/**
 *
 * @export
 * @interface ProductDescriptionSettingsDTO
 */
export interface ProductDescriptionSettingsDTO {
  /**
   * Minimum words the model is asked for (empty = default)
   * @type {number}
   * @memberof ProductDescriptionSettingsDTO
   */
  minWords?: number | null;
  /**
   * Maximum words the model is asked for (empty = default)
   * @type {number}
   * @memberof ProductDescriptionSettingsDTO
   */
  maxWords?: number | null;
  /**
   * Editorial rules block for the prompt (empty = default). Plain text, one rule per line.
   * @type {string}
   * @memberof ProductDescriptionSettingsDTO
   */
  prompt?: string | null;
  /**
   * Fields the platforms do not agree on right now; those come back as null. Saving puts every platform back in step.
   * @type {Array<string>}
   * @memberof ProductDescriptionSettingsDTO
   */
  readonly varyingFields?: Array<string>;
  /**
   * Default editorial rules (read-only)
   * @type {string}
   * @memberof ProductDescriptionSettingsDTO
   */
  readonly defaultPrompt?: string;
  /**
   * Default minimum words (read-only)
   * @type {number}
   * @memberof ProductDescriptionSettingsDTO
   */
  readonly defaultMinWords?: number;
  /**
   * Default maximum words (read-only)
   * @type {number}
   * @memberof ProductDescriptionSettingsDTO
   */
  readonly defaultMaxWords?: number;
  /**
   * Lowest configurable word count (read-only)
   * @type {number}
   * @memberof ProductDescriptionSettingsDTO
   */
  readonly wordsLowerBound?: number;
  /**
   * Highest configurable word count (read-only)
   * @type {number}
   * @memberof ProductDescriptionSettingsDTO
   */
  readonly wordsUpperBound?: number;
  /**
   * Prompt length limit in characters (read-only)
   * @type {number}
   * @memberof ProductDescriptionSettingsDTO
   */
  readonly promptMaxLength?: number;
  /**
   * Fixed prompt text above the editable rules (read-only). Holds the {minWoorden}/{maxWoorden} placeholders, so the screen can fill in the values being edited. Previewed in Dutch; a run uses the platform language.
   * @type {string}
   * @memberof ProductDescriptionSettingsDTO
   */
  readonly fixedPromptIntro?: string;
  /**
   * Fixed prompt text below the editable rules (read-only)
   * @type {string}
   * @memberof ProductDescriptionSettingsDTO
   */
  readonly fixedPromptOutro?: string;
  /**
   *
   * @type {ProductDescriptionSettingsDTOPromptPlaceholders}
   * @memberof ProductDescriptionSettingsDTO
   */
  promptPlaceholders?: ProductDescriptionSettingsDTOPromptPlaceholders;
}

/**
 * Check if a given object implements the ProductDescriptionSettingsDTO interface.
 */
export function instanceOfProductDescriptionSettingsDTO(value: object): boolean {
  let isInstance = true;

  return isInstance;
}

export function ProductDescriptionSettingsDTOFromJSON(json: any): ProductDescriptionSettingsDTO {
  return ProductDescriptionSettingsDTOFromJSONTyped(json, false);
}

export function ProductDescriptionSettingsDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProductDescriptionSettingsDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    minWords: !exists(json, "minWords") ? undefined : json["minWords"],
    maxWords: !exists(json, "maxWords") ? undefined : json["maxWords"],
    prompt: !exists(json, "prompt") ? undefined : json["prompt"],
    varyingFields: !exists(json, "varyingFields") ? undefined : json["varyingFields"],
    defaultPrompt: !exists(json, "defaultPrompt") ? undefined : json["defaultPrompt"],
    defaultMinWords: !exists(json, "defaultMinWords") ? undefined : json["defaultMinWords"],
    defaultMaxWords: !exists(json, "defaultMaxWords") ? undefined : json["defaultMaxWords"],
    wordsLowerBound: !exists(json, "wordsLowerBound") ? undefined : json["wordsLowerBound"],
    wordsUpperBound: !exists(json, "wordsUpperBound") ? undefined : json["wordsUpperBound"],
    promptMaxLength: !exists(json, "promptMaxLength") ? undefined : json["promptMaxLength"],
    fixedPromptIntro: !exists(json, "fixedPromptIntro") ? undefined : json["fixedPromptIntro"],
    fixedPromptOutro: !exists(json, "fixedPromptOutro") ? undefined : json["fixedPromptOutro"],
    promptPlaceholders: !exists(json, "promptPlaceholders")
      ? undefined
      : ProductDescriptionSettingsDTOPromptPlaceholdersFromJSON(json["promptPlaceholders"])
  };
}

export function ProductDescriptionSettingsDTOToJSON(value?: ProductDescriptionSettingsDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    minWords: value.minWords,
    maxWords: value.maxWords,
    prompt: value.prompt,
    promptPlaceholders: ProductDescriptionSettingsDTOPromptPlaceholdersToJSON(value.promptPlaceholders)
  };
}
